const Page = ({ children }) => {
  return <div className="container content">{children}</div>;
};

export default Page;
